"use client";

import * as React from "react";
import { Slider } from "./slider";
import { Volume2, VolumeX } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/DropdownMenu";

interface VolumeControlProps {
  value: number;
  onChange: (value: number) => void;
}

export function VolumeControl({ value, onChange }: VolumeControlProps) {
  const [isMuted, setIsMuted] = React.useState(false);
  const prevVolume = React.useRef(1);

  React.useEffect(() => {
    setIsMuted(value === 0);
  }, [value]);

  const handleToggleMute = () => {
    if (isMuted) {
      onChange(prevVolume.current || 0.5);
    } else {
      prevVolume.current = value;
      onChange(0);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={handleToggleMute}
          aria-label={isMuted ? "Unmute" : "Mute"}
          className="text-complement-03 xl:text-white z-0 hover:scale-[1.1] transition"
        >
          {isMuted ? (
            <VolumeX className="size-5" />
          ) : (
            <Volume2 className="size-5" />
          )}
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        side="top"
        align="center"
        className="w-28 p-3 flex items-center justify-center bg-green-04/40 border shadow-lg"
      >
        <Slider
          min={0}
          max={1}
          step={0.01}
          value={[value]}
          onValueChange={([v]) => {
            onChange(v);
            if (v > 0) prevVolume.current = v;
          }}
          className="w-full h-1.5 [&_[data-slot=slider-thumb]]:size-4 [&_[data-slot=slider-thumb]]:bg-primary"
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
